// Central branding config.
//
// Every event-specific string lives here so the same repo can serve more than
// one campaign: set the REACT_APP_* vars per deployment and the UI follows.
// Defaults below are World Heart Day.
//
// Note: the backend /settings endpoint can still override the document title at
// runtime (see TitleManager in App.js), which takes precedence over
// REACT_APP_SITE_TITLE.

export const BRAND = {
  // Full event name, used in headlines and body copy.
  eventName: process.env.REACT_APP_EVENT_NAME || "World Heart Day",

  // Short code used in generated file names (kept as WHD so existing
  // poster records and download names stay consistent).
  eventCode: process.env.REACT_APP_EVENT_CODE || "WHD",

  // Display date shown on dashboards.
  eventDate: process.env.REACT_APP_EVENT_DATE || "29 September 2026",

  // Split form for the stacked date card on the MR dashboard.
  eventDay: process.env.REACT_APP_EVENT_DAY || "29 September 2026",

  // Division logo, served from public/. Wide wordmarks and square marks both
  // work: the UI sizes it by height. BCLS uses /BCLS_LOGO.png, Excel /excel_logo.png.
  logo: process.env.REACT_APP_LOGO || "/BC logo-01.png",

  // Company / product wordmark.
  companyName: process.env.REACT_APP_COMPANY_NAME || "Blue Cross Life Sciences",
  companyShort: process.env.REACT_APP_COMPANY_SHORT || "Blue Cross",
  productName: process.env.REACT_APP_PRODUCT_NAME || "Poster Studio",

  // Login hero supporting copy.
  tagline:
    process.env.REACT_APP_TAGLINE ||
    "Upload a doctor's photo, fill the details, and download a WhatsApp-ready creative — no design team required.",
};

// Convenience: "Doctor_Name_WHD.jpg"
export const posterFileName = (doctorName, ext = "jpg") =>
  `${String(doctorName || "poster").replace(/ /g, "_")}_${BRAND.eventCode}.${ext}`;

export default BRAND;
